<template>
  <v-form>
    <v-container>
      <v-row no-gutters>
        <v-col>
          <v-text-field
            :disabled="payload.amount > 0"
            v-model="formData.amount"
            dense
            outlined
            label="Amount"
            type="number"
          />

          <v-text-field
            dense
            outlined
            v-model="formData.accountNo"
            label="Phone Number"
            type="phone"
          />
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import { mpesaShortCode } from "../environment/environment";
export default {
  name: "Mpesa",
  props: {
    payload: {
      type: Object,
      default: () => {},
    },
    test: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      formData: {
        accountNo: "",
        amount: "",
      },
    };
  },

  mounted() {
    Event.$on("checkout-0", () => {
      this.pay();
    });
  },

  computed: {
    mpesaShortCode() {
      return mpesaShortCode;
    },
  },

  methods: {
    pay: function () {
      let data = { ...this.payload, ...this.formData };

      if (this.test) {
        data.description = "TESTINGKTL";
      }

      console.log('calling stk push')

      this.$store.dispatch("Checkout/stkPush", data);
    },
  },
  watch: {
    payload: {
      handler: function () {
        this.formData.amount = this.test ? 1 : this.payload.amount;
        this.formData.accountNo = this.payload.accountNo;
      },
      immediate: true,
    },
  },
};
</script>

<style scoped></style>
